<template>
    <div v-if="isLoading" class="container">
        <content-loader class="tile-loading" />
    </div>
    <div v-else :style="{ backgroundColor: `var(${color})` }" class="container container-tile">
        <div class="value">{{ value }}</div>
        <p class="title">
            {{ titleNotBold }} <span class="titleStrong">{{ titleInBold }}</span
            ><span class="display-none">{{ titleEnd ? ` ${titleEnd}` : '' }}</span>
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ContentLoader } from 'vue-content-loader';

export default defineComponent({
    name: 'RoundedIconAndText',
    components: { ContentLoader },
    props: {
        value: { type: Number, required: true },
        color: { type: String, required: true },
        titleNotBold: { type: String, required: true },
        titleInBold: { type: String, required: true },
        isLoading: { type: Boolean, required: true },
        titleEnd: { type: String, required: false },
    },
});
</script>

<style scoped>
.container {
    position: relative;
    border-radius: 10px;
    max-height: 60px;
    flex: 1;
    overflow: hidden;
}
.container-tile {
    display: flex;
    flex-direction: column;
    color: var(--white);
    align-items: center;
    padding: 5px 10px 5px 15px;
    justify-content: space-evenly;
}
.value {
    font-size: 50px;
    font-family: 'Raleway Semi Bold', sans-serif;
    font-variant-numeric: lining-nums;
    margin-right: 15px;
}
@media (max-width: 1783px) and (min-width: 1005px) {
    .container-tile {
        padding: 0 5px 0 5px;
    }
    .value {
        margin-right: 5px;
    }
}
@media (max-width: 1501px) and (min-width: 1005px) {
    .display-none {
        display: none;
    }
}
.title {
    text-align: center;
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-300);
}
.titleStrong {
    font-family: 'Raleway Semi Bold', sans-serif;
}
.tile-loading {
    position: absolute;
}
</style>
